module.exports = __webpack_public_path__ + "img/banner5.b2880b8b.jpg";